import { featureFlagApi } from "../api/featureFlagApi";

const actions = {
  async load({ commit }) {
    const flagMap = await featureFlagApi.get();
    return commit("setState", flagMap);
  },
};

const mutations = {
  setState(state, flagMap) {
    state.flag = flagMap;
  },
};

const state = {
  flag: null,
};

const getters = {
  getFlagMap: () => state.flag,
};

export const featureFlagModule = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
